export default __webpack_public_path__ + "static/media/10-large.40c542de.jpg";